// extracted by mini-css-extract-plugin
module.exports = {"recipeSeoWrapper":"RecipeSeo_recipeSeoWrapper__krp6s","recipeSeoItem":"RecipeSeo_recipeSeoItem__KU3RU"};